import { createContext } from 'react';

import { maximumHydraulicFlowUnits } from '../../../server/enum';
import { type FormContextState } from '../../types';

export const defaultData: FormContextState = {
  flowRate: true,
  stepOne: {
    leftColumn: {
      bypassFlow: false,
      maximumHydraulicFlow: '',
      treatmentFlowRate: '',
    },
    rightColumn: {
      treatmentArea: '',
      bypassFlow: false,
      maximumHydraulicFlow: '',
      maximumHydraulicFlowUnit: maximumHydraulicFlowUnits[0],
    },
  },
  stepTwo: {
    application: '',
    infiltration: false,
    sedimentType: 'Average (DE, AT, CH)',
  },
};

type FormContextStateEx = FormContextState & {
  setData: (payload: FormContextState) => void;
  resetData: () => void;
};

export const formContextDefaultState: FormContextStateEx = {
  ...defaultData,
  setData: () => ({}),
  resetData: () => ({}),
};

export const formContext = createContext<FormContextStateEx>(
  formContextDefaultState,
);
